<script setup>
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

// ACESSO-01 (L9a): um escopo para marcar, com o rótulo, o código em Geist Mono e uma nota cinza quando há o que dizer
// (fora do grupo, ou um acesso que não se dá). Serve ao "Personalizar escopos" do editor e ao grupo da conta.
defineProps({
  escopo: { type: Object, required: true },
  nota: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
});

const marcado = defineModel({ type: Boolean, default: false });
</script>

<template>
  <label
    class="grid grid-cols-[1rem_minmax(0,1fr)] sm:grid-cols-[1rem_minmax(0,1fr)_auto] items-start gap-x-2.5 py-1.5 font-normal leading-normal"
    :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
  >
    <Checkbox
      v-model="marcado"
      :disabled="disabled"
      class="mt-0.5"
      :data-escopo="escopo.nome"
    />
    <span class="flex flex-col min-w-0">
      <span class="text-sm text-n-slate-12">{{ escopo.rotulo }}</span>
      <span v-if="nota" class="text-xs text-n-slate-11">{{ nota }}</span>
    </span>
    <code class="hidden sm:block font-mono text-xs text-n-slate-11">
      {{ escopo.nome }}
    </code>
  </label>
</template>
